<template>
    <form class="primalgo-form" @submit.prevent="calc()" novalidate>
        <div class="columns">
            <div class="column is-one-third">
                <b-field label="Anfangsinvestition">
                    <p class="control">
                        <b class="button is-static">CHF</b>
                    </p>
                    <b-input type="number" v-model="form.investment" min="0" max="5000000" step="10000" @input="calc()" expanded :use-html5-validation="false" />
                </b-field>
            </div>
            <div class="column is-one-third">
                <b-field label="Jährliche Einzahlung">
                    <p class="control">
                        <b class="button is-static">CHF</b>
                    </p>
                    <b-input type="number" v-model="form.yearly" min="5000" max="50000" step="1000" @input="calc()" expanded :use-html5-validation="false" />
                </b-field>
            </div>
            <div class="column is-one-third">
                <b-field label="Laufzeit in Jahren">
                    <b-slider v-model="form.years" :min="1" :max="20" :step="1" @change="calc()" novalidate />
                </b-field>
            </div>
        </div>
        <div class="columns">
            <div class="column is-full">
                <b-field label="Primalgo.ch Anlagestrategien *">
                    <b-select v-model="form.strategy" @input="calc()" expanded>
                        <optgroup label="Aktienstrategien">
                            <option value="a1">Aktien1 (Risiko tief)</option>
                            <option value="a2">Aktien5 (Risiko mittel)</option>
                            <option value="a3">Aktien7 (Risiko hoch)</option>
                        </optgroup>
                        <optgroup label="Portfoliostrategien">
                            <option value="p1">Multi-Asset1 (Risiko tief)</option>
                            <option value="p2">Multi-Asset5 (Risiko mittel)</option>
                            <option value="p3">Multi-Asset7 (Risiko hoch)</option>
                        </optgroup>
                    </b-select>
                </b-field>
            </div>
        </div>

        <div class="primalgo-chart" ref="chart"></div>
    </form>
</template>

<script>
import Widget from "../Widget";
import "./Widget.scss";
import ApexCharts from 'apexcharts'

export default {
    props: [],
    mixins: [Widget],
    data: () => ({
        form: {
            years: 5,
            investment: 20000,
            strategy: "p1",
            yearly: 5000,
        },
        chart: null,
        options: {
            tooltip: {
                x: {
                    show: false
                }
            },
            grid: {
                padding: {
                    top: 25,
                    left: 25,
                    right: 25
                }
            },
            colors: ["#F2CED8", "#DF869E", "#BF0D3E"],
            annotations: {
                points: [{
                    x: "3",
                    label: {
                        borderColor: "#BF0D3E",
                        style: {
                            color: "#ffffff",
                            background: '#BF0D3E',
                            fontWeight: "bold",
                            fontSize: "14px"
                        },
                    }
                }]
            },
            chart: {
                type: "bar",
                stacked: true,
                animations: {
                    enabled: true,
                    easing: 'easeinout',
                    speed: 800,
                    animateGradually: {
                        enabled: true,
                        delay: 150
                    },
                    dynamicAnimation: {
                        enabled: true,
                        speed: 350
                    }
                },
                toolbar: {
                    show: false
                }
            },
            series: [],
            xaxis: {
                categories: [],
            },
            yaxis: {
                labels: {
                    formatter: v => "CHF " + v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'"),
                    style: {
                        fontWeight: "bold"
                    }
                },
            },
            dataLabels: {
                enabled: true,
                formatter: v => v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
            }
        }
    }),
    mounted() {
        setTimeout(this.calc);
        this.stylize("primalgo-widget", "display:block");
    },
    methods: {
        range: (from, count) => [...Array(count).keys()].map(n => from + n),
        calc() {
            const years = this.range(1, parseInt(this.form.years));
            const rates = { "a1": 10, "a2": 12, "a3": 14, "p1": 4, "p2": 6, "p3": 8 };

            this.options.xaxis.categories = years.map(y => y + "");
            this.options.dataLabels.enabled = (this.form.years <= 5);
            this.options.series = [
                { 
                    name: "Anfangsinvestition",
                    data: years.map(_ => parseInt(this.form.investment))
                },
                {
                    name: "Regelmässige Einzahlungen",
                    data: years.map(y => y * this.form.yearly)
                },
                {
                    name: "Wertzuwachs Primalgo.ch",
                    data: []
                }
            ];

            let yearly = this.parseNum(this.form.yearly);
            let total = Math.min(this.parseNum(this.form.investment), 5000000) + yearly;
            let pct = rates[this.form.strategy];
            let int = Math.round(total * pct / 100);
            let acc = int;

            for (let i = 0; i < this.form.years; i++) {
                this.options.series[2].data.push(acc);

                total += int + yearly;
                int = Math.round(total * pct / 100);
                acc += int;
            }

            const totalX = [...this.options.xaxis.categories].pop();
            const totalY = this.options.series.reduce((a, b) => a + ([...b.data].pop() || 0), 0) || 0;
            const totalFmt = v => v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")

            this.options.annotations.points[0].x = totalX;
            this.options.annotations.points[0].y = totalY;
            this.options.annotations.points[0].label.text = `CHF ${totalFmt(totalY)}`;
            
            setTimeout(() => this.render());
        },
        parseNum(s, fallback) {
            const num = parseInt(s) || fallback || 0;

            return Math.max(0, num);
        },
        render() {
            if (this.chart == null) {
                this.chart = new ApexCharts(this.$refs.chart, this.options);
                this.chart.render();
            } else {
                this.chart.updateOptions(this.options);
            }
        }
    }
}
</script>

<style src="./Widget.scss" lang="scss"></style>
<style src="apexcharts/dist/apexcharts.css"></style>